module.exports = __webpack_public_path__ + "img/growth.67652255.png";